import { makeStyles } from "@mui/styles";

export const ttsCustomEditorStyles = {
  toolbarIconSize: {
    width: "20px",
    height: "20px",
  },
  toolbarMenuDivider: {
    height: "24px",
    width: "1px",
  },
};

export const numberInputStyle = makeStyles({
  input: {
    "& input[type=number]": {
      "-moz-appearance": "textfield",
    },
    "& input[type=number]::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
    "& input[type=number]::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});
